function ensureTrailingSlash(value) {
  if (!value) return "";
  return value.endsWith("/") ? value : `${value}/`;
}

/**
 * Resolve API base URL based on build mode.
 * - Dev build (Vite dev server, desktop dev renderer) -> VITE_API (local backend)
 * - Production build (app.doitify.com AND packaged desktop renderer which runs
 *   on a loopback 127.0.0.1 origin) -> VITE_API_DOMAIN
 * Hostname must NOT drive this: the packaged desktop renderer is served from
 * http://127.0.0.1:<port> and would be misread as a dev environment.
 */
export function resolveApiBaseUrl({ isDev = import.meta.env.DEV } = {}) {
  if (isDev) {
    return ensureTrailingSlash(import.meta.env.VITE_API);
  }
  return ensureTrailingSlash(import.meta.env.VITE_API_DOMAIN);
}

export function joinApiUrl(baseUrl, path) {
  const base = ensureTrailingSlash(baseUrl);
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return `${base}${cleanPath}`;
}
